var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'creativeDisabled': _vm.disabled }},[_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('div',{staticClass:"message"},[_vm._v(" This ad won't run ")])])}
var staticRenderFns = []

export { render, staticRenderFns }